import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const bigWords = ['MENOS IMPROVISACIÓN.', 'MÁS CRITERIO.', 'MÁS ESTRUCTURA.', 'MÁS MONITOR.'];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-mp-black py-24 md:py-32" data-id="element-102" data-mp="m3dpm2iqzjgo">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-40" aria-hidden="true" data-id="element-103" data-mp="h4u4g4bzabpd" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(ellipse at 50% 20%, rgba(8,93,168,0.3), transparent 65%)'
    }} aria-hidden="true" data-id="element-104" data-mp="vtqbpz67nkox" />
      <Container className="relative z-10 text-center" data-id="element-105" data-mp="14w7ta0ax7p5l">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-106" data-mp="zwmx1xn4xuwk">
          <SectionTag tone="white" data-id="element-107" data-mp="2h4spsh4ofrts">La próxima clase llegará igualmente.</SectionTag>
          <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-6xl" data-id="element-108" data-mp="2m2kuycuc1afx">
            La pregunta es si volverás a improvisarla.
          </h2>

          <div className="mx-auto mt-6 max-w-[600px] space-y-1 text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-109" data-mp="2v2hczvm7vb20">
            <p data-id="element-110" data-mp="301aq3mxld01n">No necesitas memorizar cientos de ejercicios.</p>
            <p data-id="element-111" data-mp="34sshpkdq5o9y">Necesitas saber: qué trabajar, por qué trabajarlo, cómo corregirlo y qué viene después.</p>
          </div>

          <div className="mx-auto my-10 h-px w-24 bg-mp-border" data-id="element-112" data-mp="39rdjho8mkg0i" />

          <p className="font-heading text-xl uppercase tracking-wide text-mp-lime sm:text-2xl" data-id="element-113" data-mp="3errr556bdny0">
            Eso es Maestro en Pista.
          </p>

          <div className="mx-auto mt-8 max-w-[600px] space-y-1" data-id="element-114" data-mp="3itmra6cidva7">
            {bigWords.map(word => <p key={word} className="font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl md:text-4xl" data-id="element-115" data-mp="1jov5y7tt92ka">
                {word}
              </p>)}
          </div>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista" width={700} height={700} loading="lazy" className="mx-auto mt-14 w-full max-w-[500px]" data-id="element-116" data-mp="1siro7bjutuuf" />

        <div className="mt-10" data-id="element-117" data-mp="27ded2k14j9as">
          <p className="font-heading text-xs uppercase tracking-[0.2em] text-mp-gray" data-id="element-118" data-mp="27f8uvph3mlan">Desde</p>
          <p className="font-heading text-5xl text-mp-lime sm:text-6xl" data-id="element-119" data-mp="h29qz98fno6q">17,90 €</p>
        </div>

        <CTAButton href="#oferta" className="mt-8" showArrow data-id="element-120" data-mp="d17zjekrcgfb">
          Quiero empezar con Maestro en Pista
        </CTAButton>

        <p className="mt-5 text-sm text-mp-gray" data-id="element-121" data-mp="2y2o8n8jsb3o">
          ✓ Acceso inmediato &nbsp; ✓ Pago único &nbsp; ✓ Producto digital
        </p>
      </Container>
    </section>;
}